export interface TeamPhoto {
  /** Short caption shown on the polaroid */
  caption: string;
  /** Year / date stamp shown subtly */
  year?: string;
  /**
   * Either a CSS gradient string for placeholder cards
   * (e.g. "linear-gradient(135deg, #1e293b, #0f172a)")
   * OR omit and provide `src` for a real photo.
   */
  gradient?: string;
  /** Optional URL to a real photo (overrides gradient if provided) */
  src?: string;
  /** Optional emoji shown over the gradient. Avoid in production cards. */
  emoji?: string;
}

/**
 * Default carousel photos sourced from `public/assets/login/`.
 * To swap in different shots, drop new images in that folder and update
 * the `src` paths below. Captions / years are free to edit per photo.
 */
export const DEFAULT_TEAM_PHOTOS: TeamPhoto[] = [
  {
    caption: "Synergy Sports Fest",
    year: "March 2026",
    src: "/assets/login/image1.jpg",
  },
  {
    caption: "US Team Get-Together",
    year: "July 2026",
    src: "/assets/login/image2.jpg",
  },
  {
    caption: "Earth Day Celebration",
    year: "April 2026",
    src: "/assets/login/image3.jpg",
  },
  {
    caption: "Republic Day Celebrations",
    year: "January 2026",
    src: "/assets/login/image4.jpg",
  },
  {
    caption: "Hyderabad Synergy Sports Fest",
    year: "March 2026",
    src: "/assets/login/image5.jpg",
  },
  {
    caption: "Independence Day Celebration",
    year: "August 2026",
    src: "/assets/login/image6.jpeg",
  },
  {
    caption: "",
    year: "",
    src: "/assets/login/image7.jpg",
  },
  {
    caption: "Monthly Townhall",
    year: "July 2026",
    src: "/assets/login/image8.jpg",
  },
  {
    caption: "Excursion Trip",
    year: "June 2026",
    src: "/assets/login/image9.jpg",
  },
];

export const DEFAULT_TEAM_LABEL = "Life at Caelius";
